import { Button, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { CadastrarVincularCliente } from "../../../../../clientes/containers/CadastrarVincularCliente";
import { SalvarEndereco } from "../../../../../clientes/containers/SalvarEndereco";
import { OperacaoCategoriasProdutosContainer } from "../../../../../produtos/containers/OperacaoCategoriasProdutosContainer";
import { CheckoutPaper } from "../../../../components/CheckoutPaper";
import { ClientePaper } from "../../../../components/ClientePaper";
import { EnderecoPaper } from "../../../../components/EnderecoPaper";
import { MetodoPagamentoSelect } from "../../../../components/MetodoPagamentoSelect";
import { useOperacaoContext } from "../../../../contexts/OperacaoContext";
import { TipoPedido } from "../../../../enum/TipoPedido";
import { CategoriasContainer, Layer, ProdutosPaper } from "./styles";
import { useTamanhoTela } from "../../../../../core/hooks/useTamanhoTela";
import { CarrinhoMobilePaper } from "../../styles";
import { ProdutosCarrinhoContainer } from "../../../../../produtos/containers/ProdutosCarrinhoContainer";
import { useFetchCategorias } from "../../../../../produtos/hooks/useFetchCategorias";
import { useConfiguracoesPedidoContext } from "../../../../contexts/ConfiguracoesPedidoContext";
import { GestaoEnderecosCliente } from "../../../../../clientes/containers/GestaoEnderecosCliente";
import { IEndereco } from "../../../../../core/interfaces/IEndereco";
import { IPagamentoPedido } from "../../../../interface/IPagamentoPedido";
import { useOperacaoEdicaoContext } from "../../../../contexts/OperacaoEdicaoContext";
import { ProdutosCarrinhoEdicaoContainer } from "../../../../../produtos/containers/ProdutosCarrinhoEdicaoContainer";
import { AlterarTipoPedidoSelect } from "../../../../components/AlterarTipoPedidoSelect";
import { ImprimirModal } from "../../../../components/ImprimirModal";
import { EmitirNotaFiscalModal } from "../../../Operacao/containers/EmitirNotaFiscalModal";
import { Print } from "@mui/icons-material";
import { CheckoutEdicaoPaper } from "../../../../components/CheckoutEdicaoPaper";
import { AlterarPrecoFreteModal } from "../../../../components/AlterarPrecoFreteModal";
import { BotoesAcoesCheckout } from "../../../../components/BotoesAcoesCheckout";
import { FidelidadeCardsWrapper } from "../../../../components/FidelidadeCardsWrapper";

export const OperacaoEdicaoDelivery = () => {
    const { modeloTela } = useTamanhoTela();
    const { categorias } = useFetchCategorias();

    const {
        adicionarProduto,
        adicionarProdutosCombo,
        aumentarQuantidade,
        diminuirQuantidade,
        removerProduto,
        fecharPedido,
        loading,
        alterarPagamentos,
        cancelarPedido,
        editarProduto,
        pedido,
        numeroTotalItens,
        vincularEndereco,
        loadingVincularEndereco,
        alterarTipo,
        abrirModalImpressao,
        abrirDrawerPagamento,
        abrirDrawerDividir,
        switchImprimirAutomatico,
        handleSwitchImprimirAutomatico,
        configuracaoNFCe,
        switchNotaFiscal,
        handleSwitchNotaFiscal,
        alterarValorFrete,
        cupons,
        abrirDrawerCupons,
        aplicarCupom
    } = useOperacaoEdicaoContext();

    const [modalAlterarPrecoAberta, setModalAlterarPrecoAberta] = useState(false);
    const [mostrarHorario, setMostrarHorario] = useState(false);

    const handleAlterarPagamento = (pagamento?: IPagamentoPedido) => {
        if (!pagamento?.metodoPagamento) {
            alterarPagamentos(undefined);
        } else {
            alterarPagamentos([pagamento]);
        }
    }

    return (
        <Grid
            container
            spacing={0}
            sx={{ width: "100%", height: "100%" }}
            justifyContent={"center"}
            alignItems={"center"}
        >
            <Grid item xs={12} md={9} lg={9}>
                <ProdutosPaper variant="outlined">
                    <CategoriasContainer>
                        <OperacaoCategoriasProdutosContainer
                            categorias={categorias}
                            adicionarProduto={adicionarProduto}
                            adicionarProdutosComboExterno={adicionarProdutosCombo}
                            contexto={TipoPedido["delivery"]}
                            carrinhoContainer={
                                <ProdutosCarrinhoEdicaoContainer
                                    categorias={categorias}
                                    produtosCarrinho={pedido?.produtos ?? []}
                                    aumentarQuantidade={aumentarQuantidade}
                                    diminuirQuantidade={diminuirQuantidade}
                                    removerProduto={removerProduto}
                                    editarProduto={editarProduto}
                                />
                            }
                        />
                        {pedido?.cliente && !pedido?.endereco && (
                            <Layer>
                                <GestaoEnderecosCliente
                                    cliente={pedido.cliente}
                                    salvar={vincularEndereco}
                                    opcoes={["VINCULAR_ENDERECO", "EDITAR_ENDERECO", "EXCLUIR_ENDERECO"]}
                                    loading={loadingVincularEndereco}
                                />
                            </Layer>
                        )}
                    </CategoriasContainer>
                </ProdutosPaper>
            </Grid>
            <Grid item xs={12} md={3} lg={3}>
                {pedido && (
                    <CheckoutEdicaoPaper
                        loading={loading}
                        valorFrete={pedido?.valorFrete}
                        valorTotalPedido={pedido?.valorTotal}
                        pedidoSelecionado={pedido?.uuid}
                        numeroTotalItens={numeroTotalItens}
                        numeroPedidoDiario={pedido?.numeroPedidoDiario}
                        opcoes={[
                            {
                                titulo: "Concluir",
                                funcao: fecharPedido,
                                atalho: "F8"
                            },
                            {
                                titulo: "Dividir pagamento",
                                funcao: abrirDrawerPagamento
                            },
                            {
                                titulo: "Dividir pedido",
                                funcao: abrirDrawerDividir
                            },
                            {
                                titulo: "Cancelar",
                                funcao: cancelarPedido
                            }
                        ]}
                    >
                        <AlterarTipoPedidoSelect
                            tipo={pedido?.tipo}
                            alterarTipo={alterarTipo}
                        />
                        <ClientePaper
                            cliente={pedido?.cliente}
                            desabilitar={true}
                            ocultar={true}
                            enderecoPaper={
                                <EnderecoPaper
                                    endereco={pedido?.endereco}
                                    alterarEndereco={() => vincularEndereco()}
                                    alterarPrecoFrete={() => setModalAlterarPrecoAberta(true)}
                                />
                            }
                        />
                        <FidelidadeCardsWrapper
                            cliente={pedido?.cliente}
                            cupons={cupons}
                            aplicarCupom={aplicarCupom}
                            adicionarProduto={adicionarProduto}
                            categorias={categorias || []}
                            produtos={pedido?.produtos || []}
                        />
                        <MetodoPagamentoSelect
                            pagamento={pedido?.pagamentos?.length ? pedido.pagamentos[0] : undefined}
                            onChange={handleAlterarPagamento}
                            valorTotal={pedido?.valorTotal}
                        />
                        <BotoesAcoesCheckout
                            switchImprimirAutomatico={switchImprimirAutomatico}
                            handleSwitchImprimirAutomatico={handleSwitchImprimirAutomatico}
                            switchNotaFiscal={switchNotaFiscal}
                            handleSwitchNotaFiscal={handleSwitchNotaFiscal}
                            configuracaoNFCeObrigatorio={configuracaoNFCe?.obrigatorio}
                            quantidadeCupons={cupons.length}
                            abrirDrawerCupons={abrirDrawerCupons}
                            abrirModalComandas={abrirModalImpressao}
                        />
                        {modeloTela == "mobile" && (pedido?.produtos && pedido?.produtos?.length > 0) && (
                            <CarrinhoMobilePaper variant="outlined" sx={{ marginTop: "1rem" }}>
                                <ProdutosCarrinhoEdicaoContainer
                                    categorias={categorias}
                                    produtosCarrinho={pedido?.produtos}
                                    aumentarQuantidade={aumentarQuantidade}
                                    diminuirQuantidade={diminuirQuantidade}
                                    removerProduto={removerProduto}
                                    editarProduto={editarProduto}
                                />
                            </CarrinhoMobilePaper>
                        )}
                        <AlterarPrecoFreteModal
                            open={modalAlterarPrecoAberta}
                            valorAtual={pedido?.valorFrete ?? pedido?.endereco?.regiao?.preco}
                            onClose={() => setModalAlterarPrecoAberta(false)}
                            onConfirm={async (novoValor) => {
                                await alterarValorFrete(novoValor);
                                setModalAlterarPrecoAberta(false);
                            }}
                            loading={loading}
                        />
                    </CheckoutEdicaoPaper>
                )}
            </Grid>
        </Grid>
    );
}